import React from "react";
import { Fab, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import ReadOnlyIcon from "../../../assets/favicon/ReadOnly.png";

export default function PATEditButton(props) {
  const {
    onClick,
    disabled,
    size,
    tooltipText,
    entityFlag,
    viewOnly,
    className,
  } = props;

  if (entityFlag === "tags" && viewOnly) {
    return null;
  }

  const button = (
    <Fab
      size="small"
      disabled={disabled}
      color="secondary"
      aria-label="edit"
      onClick={onClick}
      className={className || ""}
    >
      {viewOnly ? (
        <img src={ReadOnlyIcon} width={25} alt="Edit Button" />
      ) : (
        <EditIcon style={{ fontSize: size }} />
      )}
    </Fab>
  );

  return (
    <Tooltip
      title={
        viewOnly
          ? tooltipText?.replace("Edit", "View") || "View"
          : tooltipText || "Edit"
      }
    >
      {/* Wrap in span only if disabled */}
      {disabled ? <span>{button}</span> : button}
    </Tooltip>
  );
}
